export default {

    emits: ['update:loading'],

    props: {

        loading: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isLoading: this.loading
        }
    },

    watch: {
        loading(loading) {
            this.isLoading = loading;
        },

        isLoading(isLoading) {
            this.$emit('update:loading', isLoading)
        }
    }
}
